import RequestCandidatesDocuments from './RequestCandidatesDocuments.page';

export default RequestCandidatesDocuments;